import { render, staticRenderFns } from "./ProductCommentModal.vue?vue&type=template&id=2f518244"
import script from "./ProductCommentModal.vue?vue&type=script&lang=js"
export * from "./ProductCommentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports